<div class="page-container">
    <div fxLayout="column">
        <app-page-header [section]="'Atoku'" [title]="'Categories'"
            [description]="'Manage category entities with code, logo, and theme.'"></app-page-header>

        <div class="page-padding page-content full-screen-height-page-default" fxLayout="column">
            <div class="atoku-filter-bar" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
                <mat-form-field class="custom-text-field atoku-search-field" appearance="outline" floatLabel="always">
                    <mat-label>Search</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Search by code or name...">
                    <mat-icon matSuffix color="primary">search</mat-icon>
                </mat-form-field>
            </div>

            <div class="table-card mat-elevation-z3" fxLayout="column">
                <div class="atoku-card-header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="12px">
                        <div class="atoku-card-actions">
                            <button class="button-action" mat-flat-button type="button" (click)="openAddDialog()">
                                <mat-icon>add</mat-icon>
                                <div class="button-text">Create Category</div>
                            </button>

                            <button class="button-action" mat-flat-button type="button" *ngIf="hasSingleSelection"
                                (click)="editSelectedCategory()">
                                <mat-icon>edit</mat-icon>
                                <div class="button-text">Edit</div>
                            </button>

                            <button class="button-action" mat-flat-button type="button" *ngIf="hasSelection"
                                (click)="removeSelectedCategories()">
                                <mat-icon>delete</mat-icon>
                                <div class="button-text">Remove</div>
                            </button>
                        </div>
                    </div>
                </div>

                <table mat-table class="custom-table" [dataSource]="dataSource">
                    <ng-container matColumnDef="table-label">
                        <th mat-header-cell class="custom-table-label" *matHeaderCellDef
                            [attr.colspan]="displayedColumns.length"> Category Entities </th>
                    </ng-container>

                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let row">
                            <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                                (change)="toggleRow(row)" [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef> Code </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{ element.code }} </td>
                    </ng-container>

                    <ng-container matColumnDef="displayName">
                        <th mat-header-cell *matHeaderCellDef> Display Name </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{ element.displayName }} </td>
                    </ng-container>

                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef> Description </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{ element.description }} </td>
                    </ng-container>

                    <ng-container matColumnDef="logo">
                        <th mat-header-cell *matHeaderCellDef> Logo </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element">
                            <img class="logo-thumb" [src]="getLogoPreview(element)" alt="Category logo">
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="theme">
                        <th mat-header-cell *matHeaderCellDef> Theme </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{ element.theme }} </td>
                    </ng-container>

                    <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
                    <tr mat-header-row class="custom-table-header" *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row class="custom-table-row" *matRowDef="let row; columns: displayedColumns;"
                        (click)="toggleRow(row)" [class.atoku-selected-row]="selection.isSelected(row)"></tr>
                </table>

                <mat-paginator #paginator class="custom-paginator" [pageSize]="10"
                    [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
            </div>
        </div>
    </div>
</div>
